import request from '@/utils/request'

let AppraisalApi = {
  categoryIndex(data, errorback) {
    return request._get('/shop/appraisal.category/index', data, errorback);
  },
  categoryAdd(data, errorback) {
    return request._post('/shop/appraisal.category/add', data, errorback);
  },
  getCategoryEdit(data, errorback) {
    return request._get('/shop/appraisal.category/edit', data, errorback);
  },
  setCategoryEdit(data, errorback) {
    return request._post('/shop/appraisal.category/edit', data, errorback);
  },
  categoryDelete(data, errorback) {
    return request._post('/shop/appraisal.category/delete', data, errorback);
  },


  finenessIndex(data, errorback) {
    return request._get('/shop/appraisal.fineness/index', data, errorback);
  },
  finenessAdd(data, errorback) {
    return request._post('/shop/appraisal.fineness/add', data, errorback);
  },
  setFinenessEdit(data, errorback) {
    return request._post('/shop/appraisal.fineness/edit', data, errorback);
  },
  getFinenessEdit(data, errorback) {
    return request._get('/shop/appraisal.fineness/edit', data, errorback);
  },
  finenessDelete(data, errorback) {
    return request._post('/shop/appraisal.fineness/delete', data, errorback);
  },



  attachmentIndex(data, errorback) {
    return request._get('/shop/appraisal.attachment/index', data, errorback);
  },
  attachmentAdd(data, errorback) {
    return request._post('/shop/appraisal.attachment/add', data, errorback);
  },
  setAttachmentEdit(data, errorback) {
    return request._post('/shop/appraisal.attachment/edit', data, errorback);
  },
  getAttachmentEdit(data, errorback) {
    return request._get('/shop/appraisal.attachment/edit', data, errorback);
  },
  attachmentDelete(data, errorback) {
    return request._post('/shop/appraisal.attachment/delete', data, errorback);
  },


  appraisalIndex(data, errorback) {
    return request._get('/shop/appraisal.appraisal/index', data, errorback);
  },
  appraisalDetail(data, errorback) {
    return request._get('/shop/appraisal.appraisal/detail', data, errorback);
  },
  appraisalAddResultImage(data, errorback) {
    return request._post('/shop/appraisal.appraisal/addResultImage', data, errorback);
  },


}
export default AppraisalApi;



// WEBPACK FOOTER //
// ./src/api/appraisal.js